import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useGetTokenQuery } from '../../../../services/api';
import { useAppDispatch } from '../../../../hooks/useRedux';
import { setCredentials } from '../../../../features/authSlice';
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
  setToken,
} from '../../../../utils/storage';

export default function NaverLoginCallback() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new (URLSearchParams as any)(location.search);
  const code = params.get('code');
  const state = params.get('state');
  const { data, isLoading } = useGetTokenQuery({ code, state });

  useEffect(() => {
    if (isLoading) return;

    if (data.message === 'OK') {
      const { isJoin, token, userProfile } = data.data;
      if (isJoin) {
        const { accessToken, refreshToken } = token;
        setToken({ accessToken, refreshToken });
        dispatch(
          setCredentials({
            accessToken,
            refreshToken,
            loginType: 'naver',
          })
        );
        navigate('/home', {
          replace: true,
        });
        setLocalStorage('loggedIn', 1);
      } else {
        navigate('/login/signup', {
          replace: true,
          state: { userProfile },
        });
      }
    } else {
      navigate('/login', { replace: true });
    }
  }, [isLoading, data]);

  return null;
}
